import React from 'react';
import { useTranslation } from '../../i18n/i18n';
import './Spinner.scss';

const Spinner = ({ label }: { label?: string }) => {
  const { t } = useTranslation('common');
  return (
    <div className="Spinner" role="status">
      <span className="Spinner__ring" aria-hidden="true" />
      <span>{label ?? t('loading')}</span>
    </div>
  );
};

export default Spinner;
